var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1915_201270)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.4895 10.1868C20.4895 9.36743 20.4214 8.76949 20.2742 8.14941H10.6992V11.8477H16.3195C16.2062 12.7668 15.5943 14.1509 14.2346 15.081L14.2155 15.2048L17.2429 17.4967L17.4527 17.5171C19.379 15.7786 20.4895 13.2208 20.4895 10.1868Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7002 19.9312C13.4537 19.9312 15.7653 19.0453 17.4537 17.5173L14.2356 15.0812C13.3744 15.6681 12.2186 16.0778 10.7002 16.0778C8.0034 16.0778 5.7145 14.3394 4.89857 11.9365L4.77897 11.9464L1.63101 14.3271L1.58984 14.439C3.26686 17.6944 6.71158 19.9312 10.7002 19.9312Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.8965 11.9363C4.68121 11.3163 4.55661 10.6518 4.55661 9.96534C4.55661 9.27878 4.68121 8.61443 4.88517 7.99435L4.87947 7.86229L1.69206 5.44336L1.58778 5.49183C0.8966 6.84275 0.5 8.35977 0.5 9.96534C0.5 11.5709 0.8966 13.0879 1.58778 14.4388L4.8965 11.9363Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7002 3.85336C12.6152 3.85336 13.9069 4.66168 14.6435 5.33717L17.5216 2.59107C15.754 0.985496 13.4537 0 10.7002 0C6.71158 0 3.26686 2.23672 1.58984 5.49214L4.88724 7.99466C5.7145 5.59183 8.0034 3.85336 10.7002 3.85336Z",
    fill: "#EB4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1915_201270"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.015e5093066651e3b7a218efdf6512eb.svg";
export { ForwardRef as ReactComponent };